import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

const CreateNotification = props => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["notificationManagement"]);
  const { addToast } = useToasts();

  const notificationManagement = useSelector(state => state.notificationManagement);
  const {
    loadingCreate,
    errorCreate,
    create: notificationCreate,
  } = notificationManagement;

  return <div>CreateNotification</div>;
};

export default CreateNotification;
